import { render, staticRenderFns } from "./declaredetail.vue?vue&type=template&id=7471c66a&scoped=true"
import script from "./declaredetail.vue?vue&type=script&lang=js"
export * from "./declaredetail.vue?vue&type=script&lang=js"
import style0 from "./declaredetail.vue?vue&type=style&index=0&id=7471c66a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471c66a",
  null
  
)

export default component.exports